// extracted by mini-css-extract-plugin
export default {"box":"Search_box__emBej","open":"Search_open__6i+1M","list":"Search_list__NEVVu","option":"Search_option__ThHwt","reset":"Search_reset__rlPQJ","icon":"Search_icon__XMmYc"};